import { API_INSTANCE, fullBuildURL } from 'src/features/utils';

export const fetchAllUserSitesApi = async () =>
  await API_INSTANCE.get(fullBuildURL(`/api/v1/dashboard/sites`));
